import {Component, Input, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {AssetLien} from '../../../shared/domain/item/asset-lien.model';
import {DialogService} from '@rbaip/ui-component';
import {Validators, FormGroup, FormBuilder, FormControl} from '@angular/forms';
import {AssetLienService} from '../shared/asset-lien-service';

@Component({
  selector: 'lib-item-summary-asset-lien-edit',
  templateUrl: './asset-lien-edit.component.html',
  styleUrls: ['./asset-lien-edit.component.scss']
})
export class AssetLienEditComponent implements OnInit {
  @Input() origItem: AssetLien;
  @Input() editing: boolean;

  item: AssetLien;
  isBlanket: boolean;
  saveAttempted: boolean;
  public successMessage = '';
  public errorMessage = '';

  formBuilder: FormBuilder = new FormBuilder();
  assetLienForm: FormGroup;
  emailAddressCtrl: FormControl;
  phoneNumberCtrl: FormControl;
  faxNumberCtrl: FormControl;
  amountOwingCtrl: FormControl;
  newObject: {};

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private dialogRef: MatDialogRef<AssetLienEditComponent>,
              private dialogService: DialogService,
              private assetLienService: AssetLienService) {
    if (data) {
      this.origItem = data.item;
      this.item = Object.assign(new AssetLien(), JSON.parse(JSON.stringify(data.item)));
      this.editing = data.editing;
      this.isBlanket = !this.item.assetId;
    }
  }

  ngOnInit() {
    this.buildForm();
    this.fillInForm(this.item);
  }

  private buildForm() {
    const phoneNumberRegex = '^\\+?(\\d|-| |\\(|\\))*$';
    const priceRegex = "^[0-9]*[.]?[0-9]*$";

    this.emailAddressCtrl = new FormControl('', {
      validators: [Validators.email],
      updateOn: 'blur'
    });
    this.emailAddressCtrl.valueChanges.subscribe(emailAddress => {
      this.item.email = emailAddress;
    });

    this.phoneNumberCtrl = new FormControl('', {
      validators: [Validators.pattern(phoneNumberRegex)],
      updateOn: 'blur'
    });
    this.phoneNumberCtrl.valueChanges.subscribe(phoneNumber => {
      this.item.phone = phoneNumber;
    });

    this.faxNumberCtrl = new FormControl('', {
      validators: [Validators.pattern(phoneNumberRegex)],
      updateOn: 'blur'
    });
    this.faxNumberCtrl.valueChanges.subscribe(faxNumber => {
      this.item.fax = faxNumber;
    });

    this.amountOwingCtrl = new FormControl('', {
      validators: [Validators.pattern(priceRegex)],
      updateOn: 'blur'
    });
    this.amountOwingCtrl.valueChanges.subscribe(amountOwing => {
      this.item.amountOwing = amountOwing;
    });

    this.assetLienForm = this.formBuilder.group({
      emailAddress: this.emailAddressCtrl,
      phoneNumber: this.phoneNumberCtrl,
      faxNumber: this.faxNumberCtrl,
      amountOwing: this.amountOwingCtrl
    });
  }

  private fillInForm(assetLien: AssetLien) {
    this.emailAddressCtrl.setValue(assetLien.email);
    this.phoneNumberCtrl.setValue(assetLien.phone);
    this.faxNumberCtrl.setValue(assetLien.fax);
    this.amountOwingCtrl.setValue(assetLien.amountOwing);
  }

  public saveLienHolder() {
    this.saveAttempted = true;
    this.resetSuccessMessage();
    this.resetErrorMessage();
    if (this.assetLienForm && !this.assetLienForm.valid) {
      this.errorMessage = 'Lien Info is invalid';
      this.saveAttempted = false;
    } else {
      this.dialogService.showProgress();
      if (!this.isBlanket && this.item.assetId == -1) {
        // New asset, create lien record when asset is created
        this.successMessage = 'Successfully saved lienholder info!';
        this.dialogService.hideProgress();

        setTimeout(() => this.dialogRef.close([this.item, false]), 1000);
      } else {
        const list = [this.item];
        const blanketFlag = this.isBlanket ? 'Y' : 'N';
        this.assetLienService.createNewLien(list, blanketFlag)
          .subscribe(response => {
            if (response && response.error) {
              this.errorMessage = response.getErrorMessage() ? response.getErrorMessage() : 'Failed to save lienholder info!';
              this.saveAttempted = false;
            } else {
              this.successMessage = 'Successfully saved lienholder info!';
              this.dialogService.hideProgress();

              setTimeout(() => this.dialogRef.close([response, false]), 1000);
            }
          });
      }
    }
  }

  public deleteLienHolder() {
    this.saveAttempted = true;
    this.resetSuccessMessage();
    this.resetErrorMessage();
    this.dialogService.showProgress();
    if (!this.isBlanket && this.item.assetId == -1) {
      // New asset
      this.successMessage = 'Successfully deleted lienholder info!';
      this.dialogService.hideProgress();

      setTimeout(() => this.dialogRef.close([this.item, true]), 1000);
    } else {
      this.assetLienService.deleteLien(this.item.lienId)
        .subscribe(response => {
          if (response && response.error) {
            this.errorMessage = response.getErrorMessage() ? response.getErrorMessage() : 'Failed to save lienholder info!';
            this.saveAttempted = false;
          } else {
            this.successMessage = 'Successfully deleted lienholder info!';
            this.dialogService.hideProgress();

            setTimeout(() => this.dialogRef.close([this.item, true]), 1000);
          }
        });
    }
  }

  private resetSuccessMessage(): void {
    this.successMessage = '';
  }

  private resetErrorMessage(): void {
    this.errorMessage = '';
  }

}
